import loader from './loader.vue';
import smartInput from './smartInput.vue';
import tooltip from './tooltip.vue';
import spinner from './spinner.vue';
import smartSelect from './smartSelect.vue';
import lineLoader from './lineLoader.vue';
import numberInput from './numberInput.vue';


export {
  loader,
  smartInput,
  tooltip,
  spinner,
  smartSelect,
  lineLoader,
  numberInput,
};

export default {
  loader,
  smartInput,
  tooltip,
  spinner,
  smartSelect,
  lineLoader,
  numberInput,
};
